export default (that) => [
  {
    field: "seq",
    minWidth: 40,
    align: "center",
    fixed: "left",
    type: "seq",
  },
  {
    field: "col-opt",
    title: that.$l("INDEX.table_label_operation") || "操作",
    headerAlign: "center",
    align: "center",
    minWidth: 80,
    slots: {
      default: "opt",
    },
  },
  {
    title: that.$l("table_label_expenseType") || "费用类型",
    field: "v_expenseType",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("INDEX.table_label_price") || "单价",
    field: "price",
    headerAlign: "center",
    align: "center",
    minWidth: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("table_label_qty") || "数量",
    field: "qty",
    headerAlign: "center",
    align: "center",
    minWidth: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("INDEX.order_goods_label_subAmount") || "小计金额",
    field: "subAmount",
    headerAlign: "center",
    align: "center",
    minWidth: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("table_label_expenseDescription") || "费用说明",
    field: "expenseDescription",
    align: "center",
    minWidth: 220,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
